module.exports = __webpack_public_path__ + "img/app_screen.bfe2a918.png";